// extracted by mini-css-extract-plugin
module.exports = {"animation":"style_animation__ALEkt","mainContainer":"style_mainContainer___1CKJ","cardsContainer":"style_cardsContainer__gSaxQ","cardContainer":"style_cardContainer__cD_LP"};